// src/config/firebase.js - Configuración de Firebase
import { initializeApp } from 'firebase/app';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  CACHE_SIZE_UNLIMITED,
} from 'firebase/firestore';
import { getMessaging, getToken, isSupported } from 'firebase/messaging';
import { getAuth } from 'firebase/auth';

// Si existen variables REACT_APP_FIREBASE_* usa el proyecto de dev, si no el de producción
const firebaseConfig = process.env.REACT_APP_FIREBASE_PROJECT_ID ? {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
} : {
  apiKey: "AIzaSyAPVDARw4WvtF5KM-vPgGYRU7malRuThYQ",
  authDomain: "zapataapp-490b3.firebaseapp.com",
  projectId: "zapataapp-490b3",
  storageBucket: "zapataapp-490b3.firebasestorage.app",
  messagingSenderId: "662626147238",
  appId: "1:662626147238:web:a81a99877fc676556d0d67",
  measurementId: "G-9BYZ72T5DN"
};

// Clave VAPID pública — obtenida en Firebase Console > Project Settings > Cloud Messaging > Web Push certificates
export const FCM_VAPID_KEY = process.env.REACT_APP_FCM_VAPID_KEY || '';

const app = initializeApp(firebaseConfig);

// Firebase Auth — el login canjea un custom token (signInWithCustomToken) para
// que request.auth deje de ser null en las reglas de Firestore. El SDK persiste
// la sesión en IndexedDB y renueva el ID token solo.
export const auth = getAuth(app);

// Persistencia IndexedDB — los técnicos pueden trabajar sin cobertura y los cambios
// se sincronizan automáticamente al reconectarse. Multi-tab: cada pestaña ve los mismos datos.
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
    cacheSizeBytes: CACHE_SIZE_UNLIMITED,
  }),
});

// Inicializa messaging solo si el navegador lo soporta (no en Safari antiguo ni SSR)
export async function getMessagingInstance() {
  const supported = await isSupported();
  if (!supported) return null;
  return getMessaging(app);
}

export { getToken };
export default app;